 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		57: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"a9a7754c","2":"cb1608f2","3":"dd4a9b86b77a8cb6cefa82f32104cdb87e040645","6":"component---src-pages-404-js","7":"component---src-pages-alert-research-mdx","8":"component---src-pages-avatar-research-mdx","9":"component---src-pages-badge-research-mdx","10":"component---src-pages-breadcrumb-research-mdx","11":"component---src-pages-button-research-mdx","12":"component---src-pages-card-research-mdx","13":"component---src-pages-checkbox-checkbox-proposal-mdx","14":"component---src-pages-checkbox-checkbox-research-concepts-mdx","15":"component---src-pages-checkbox-checkbox-research-findings-mdx","16":"component---src-pages-checkbox-checkbox-research-mdx","17":"component---src-pages-component-name-matrix-mdx","18":"component---src-pages-component-research-template-mdx","19":"component---src-pages-component-spec-template-mdx","20":"component---src-pages-contribute-js","21":"component---src-pages-datepicker-research-mdx","22":"component---src-pages-dialog-research-mdx","23":"component---src-pages-documentation-charter-mdx","24":"component---src-pages-documentation-design-system-analysis-guide-mdx","25":"component---src-pages-documentation-get-involved-mdx","26":"component---src-pages-documentation-glossary-mdx","27":"component---src-pages-documentation-proposal-guide-mdx","28":"component---src-pages-documentation-roles-mdx","29":"component---src-pages-documentation-working-mode-mdx","30":"component---src-pages-file-file-proposal-mdx","31":"component---src-pages-file-file-research-examples-mdx","32":"component---src-pages-file-file-research-mdx","33":"component---src-pages-flex-research-mdx","34":"component---src-pages-icon-research-mdx","35":"component---src-pages-image-research-mdx","36":"component---src-pages-mission-research-mdx","37":"component---src-pages-popup-popup-research-explainer-mdx","38":"component---src-pages-popup-popup-research-mdx","39":"component---src-pages-select-select-proposal-mdx","40":"component---src-pages-select-select-research-api-mdx","41":"component---src-pages-select-select-research-behavior-mdx","42":"component---src-pages-select-select-research-mdx","43":"component---src-pages-skeleton-research-mdx","44":"component---src-pages-slider-research-mdx","45":"component---src-pages-slider-research-parts-mdx","46":"component---src-pages-switch-research-mdx","47":"component---src-pages-table-proposal-mdx","48":"component---src-pages-table-research-mdx","49":"component---src-pages-tabs-proposal-mdx","50":"component---src-pages-tabs-research-markup-mdx","51":"component---src-pages-tabs-research-mdx","52":"component---src-pages-tabs-research-parts-mdx","53":"component---src-pages-text-research-mdx","54":"component---src-pages-toast-research-mdx","55":"component---src-pages-tooltip-research-mdx"}[chunkId]||chunkId) + "-" + {"1":"e8e767897b2103dd31ee","2":"2109f057901f45daa7e1","3":"11fa63380b374ebe0b0b","6":"bb79d4329b51e4182187","7":"1d7eba7661b0deff84f0","8":"23c786b1f6d71c09d78b","9":"b3d0c4c1a8e923ee01d1","10":"d3021963d3ce1e5b0bbd","11":"a695fa8e2647106956c3","12":"5bf48cb7d6b44ebe5bdf","13":"590c5237b23dda8a02d3","14":"91447cbea6357488ff66","15":"ededfe74973cb1882afb","16":"d1eacf13d8ec328725e1","17":"7802363559ca48e4c4cd","18":"854fe9e168d08ee5270a","19":"e1d66629cde662615681","20":"d211732292e358ff5e16","21":"5020226cf5851fe9ebb8","22":"e092402636d20cee0ab0","23":"ec88f4dd3f2ffe992562","24":"2a2cf907c6ddfa80cd7c","25":"f70a17ad47a03243909e","26":"b34d61f875508039a503","27":"129452fa24ad06e589c0","28":"cbfeb0a1205b7a42dfb6","29":"a44d2016a48d310e21c8","30":"f1727337deb64c649914","31":"97b9530213a644b58e22","32":"864425b24a5b049c27bf","33":"78409de8776cde65ac24","34":"f0044607b759466e9c3d","35":"e0afe7be31ef384dfaec","36":"8d6127900dae006547ee","37":"11f7bec4c8a68ef2e3c8","38":"4c1212196fd761c08cd6","39":"a76116e54cef4fdf0df2","40":"f3ae28e94fcc6241976e","41":"5c1c12a3214a3546ca19","42":"71efdcb671f84e6e295e","43":"5c7668cdc796f68ab523","44":"965766353933f253d7a9","45":"6a41b608350b2dcd2e5b","46":"c29a3c1a0b6474576c8e","47":"90bb5ce7183783887841","48":"fe5045374c66d1d40e82","49":"9e03314ec054c3d8a927","50":"049dbb9206388c578554","51":"00ddce8bf587ae9372c7","52":"90d2878aa28cc69d3e31","53":"a69e8c18ea6a1b4203ab","54":"4d77999b844db3a76789","55":"8be7b2c0b0cc911af8b0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
